// src/components/admin/TeamAssignmentChip.tsx
import React from "react";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface TeamAssignmentChipProps {
  teamName: string;
  onRemove?: () => void;
  disabled?: boolean;
}

const TeamAssignmentChip: React.FC<TeamAssignmentChipProps> = ({ teamName, onRemove, disabled }) => (
  <Chip
    label={teamName}
    size="small"
    onDelete={onRemove}
    deleteIcon={onRemove ? <CloseIcon sx={{ fontSize: 14 }} /> : undefined}
    disabled={disabled}
    sx={{
      bgcolor: "#EFF6FF",
      color: "#1D4ED8",
      fontWeight: 500,
      fontSize: "0.75rem",
      height: 24,
      mr: 0.5,
      mb: 0.5,
      "& .MuiChip-deleteIcon": { color: "#1D4ED8", "&:hover": { color: "#1e40af" } },
    }}
  />
);

export default TeamAssignmentChip;
